import { authedFetch } from '@/providers/loginWithEmail/dataProvider';

export type ProjectNumberUpdateResult = {
    id: number;
    project_no: number;
    name: string;
};

function parseProjectNumberError(data: unknown, fallback: string): string {
    if (!data || typeof data !== 'object') return fallback;
    const obj = data as Record<string, unknown>;
    const errors = obj.errors;
    if (errors && typeof errors === 'object') {
        const root = (errors as Record<string, unknown>).root;
        if (typeof root === 'string') return root;
        if (root && typeof root === 'object' && root !== null && 'serverError' in root) {
            return String((root as { serverError: unknown }).serverError);
        }
    }
    const detail = obj.detail;
    if (typeof detail === 'string') return detail;
    if (detail && typeof detail === 'object') {
        const root = (detail as Record<string, unknown>).root;
        if (typeof root === 'string') return root;
        if (root && typeof root === 'object' && root !== null && 'serverError' in root) {
            return String((root as { serverError: unknown }).serverError);
        }
    }
    return fallback;
}

export async function updateProjectNumber(
    projectId: number,
    projectNo: number
): Promise<ProjectNumberUpdateResult> {
    const res = await authedFetch(
        `/projects/${projectId}/project-no`,
        {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ project_no: projectNo }),
        }
    );
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        throw new Error(parseProjectNumberError(data, 'Failed to update project number'));
    }
    return data as ProjectNumberUpdateResult;
}
